import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AuthPermissionService } from "./shared/services/auth-permission.service";
import { AuthService } from "./shared/services/auth.service";
import { TranslationService } from "./shared/services/translation.service";

@Component({
  selector: "app-root",
  imports: [RouterOutlet],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  url = window.location.hostname;
  subdomain = "";
  title = "armstracker-web";
  userInfo: any;
  constructor(
    private _translations: TranslationService,
    private _auth: AuthService,
    private _permissionsService: AuthPermissionService
  ) {
    this._translations.setLanguage("en");
    this.userInfo = this._auth.getUserInfo();
    if (this.userInfo) {
      this._permissionsService
        .getAuthPermissions()
        .pipe()
        .subscribe((data) => {});
    }
    this._auth
      .getAgencyDetails()
      .pipe()
      .subscribe((data) => {});
  }

  ngOnInit() {
    this.subdomain = window.location.host.split(".")[0];
  }
}
